import _ from 'lodash';
import Storage from '../../utils/Storage';

export default class SaveMultipartFormData {
	constructor() {
		this.api_url = process.env.API_URL;
	}

	save( data ) {
		const url       = (data.url) ? data.url : '';
		const form_data = (data.formData) ? data.formData : {};

		return $.ajax( {
			url:        this.api_url + url,
			data:        this._prepareFormData( form_data ),
			processData: false,
			contentType: false,
			type:        'POST',
			beforeSend:  ( xhr, settings ) => {
				if (process.env.IS_SID === 'true') {
					let getSid = Storage.get( 'sid' ) || '';
					settings.data.append( 'sid', getSid );
				}

			}
		} ).promise();
	}

	_prepareFormData( data ) {
		_.each( data, function ( value, key ) {
			if ( _.isBoolean( value ) ) {
				data[ key ] = +value;
			}
		}, this );
		let formData = new FormData();
		_.each( data, function ( value, key ) {
			if ( value instanceof File ) {
				formData.append( key, value );
				return;
			}
			formData.append( key, value );
		} );

		return formData;
	}
}